// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './common/font.css';
import {
  videoPlayer
} from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import * as api from './utils/axios';

Vue.prototype.$video = videoPlayer
Vue.prototype.$api = api

Vue.config.productionTip = false
Vue.use(ElementUI);

// export default{
//   beforeEach(to,from,next){
//     console.log(to,from,next,'ss');
//   }
// }
router.beforeEach((to, from, next) => { //添加前置路由守卫
  window.scroll(0, 0);
  next();
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 根据路由设置页面title
  // console.log(to,document,'666');
  document.title = to.meta.title || "默认标题";
  if (to.meta && to.meta.keywords) {
    const meta = document.querySelector('meta[name="keywords"]');
    if (meta) {
      meta.setAttribute('content', to.meta.keywords);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'keywords');
      newMeta.setAttribute('content', to.meta.keywords);
      document.head.appendChild(newMeta);
    }
  }
  if(to.meta && to.meta.description){
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', to.meta.description);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'description');
      newMeta.setAttribute('content', to.meta.description);
      document.head.appendChild(newMeta);
    }
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js